import * as React from 'react';

import { portraits } from './portrait_images';
import { Gallery } from '../core/Gallery';

export const PortraitSection = () => {
  return <Gallery images={portraits} />;
};
